import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-G1T3X32KYN";

/**
 * Fires a GA4 page_view event on every SPA route change.
 * The gtag script is already loaded via index.html with send_page_view=false,
 * so we fully control page_view timing here.
 */
export default function GAPageview() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const page_path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search]);

  return null;
}
